import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxLabel, CheckboxInput, CheckIcon } from './styled';

const TableCheckbox = ({ 
    checked, 
    onChange, 
    id, 
    readOnly = false,
    ...rest 
}) => {
    const handleChange = (e) => {
        if (!readOnly && onChange) {
            onChange(e);
        }
    };

    const handleLabelClick = (e) => {
        // Prevent double triggering if clicking directly on the label
        if (e.target.tagName !== 'INPUT' && !readOnly && onChange) {
            const syntheticEvent = {
                ...e,
                target: {
                    ...e.target,
                    checked: !checked
                },
                currentTarget: e.currentTarget.querySelector('input')
            };
            onChange(syntheticEvent);
        }
    };

    const checkboxId = id || `table-checkbox-${Math.random().toString(36).substr(2, 9)}`;

    // Filter out non-HTML attributes that React doesn't recognize
    const validInputProps = {};
    const invalidProps = ['rowKey', 'rowIndex', 'mode', 'clickToSelect'];
    
    Object.keys(rest).forEach(key => {
        if (!invalidProps.includes(key)) {
            // Only include valid HTML attributes or data-* attributes
            if (
                key.startsWith('data-') || 
                key.startsWith('aria-') || 
                ['name', 'value', 'tabIndex', 'autoFocus', 'className'].includes(key) ||
                key.match(/^on[A-Z]/) // Event handlers
            ) {
                validInputProps[key] = rest[key];
            }
        }
    });

    return (
        <CheckboxLabel
            htmlFor={checkboxId}
            onClick={handleLabelClick}
            checked={checked}
            readOnly={readOnly}
        >
            <CheckboxInput
                type="checkbox"
                id={checkboxId}
                checked={checked}
                onChange={handleChange}
                readOnly={readOnly}
                disabled={readOnly}
                {...validInputProps}
            />
            {checked && (
                <CheckIcon 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="14" 
                    height="14" 
                    viewBox="0 0 14 14" 
                    fill="none"
                >
                    <path 
                        d="M11.6666 3.5L5.24992 9.91667L2.33325 7" 
                        stroke="#17B26A" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </CheckIcon>
            )}
        </CheckboxLabel>
    );
};

TableCheckbox.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    id: PropTypes.string,
    readOnly: PropTypes.bool
};

export default TableCheckbox;

